module.exports = __webpack_public_path__ + "media/images/home/icon-3-49c41ff0e01d77aa867c68efdc14a61e.png";